import ReactDOM from 'react-dom';
import './src/styles/global.css';

export const replaceHydrateFunction = () => (element, container, callback) => {
  ReactDOM.render(element, container, callback);
};
